import { Dialog, Button, P } from '@fashionnovateam/nova-ui-toolkit';
import React from 'react';

export interface ArchiveConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  action?: 'archive' | 'unarchive';
}

export function ArchiveConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  action = 'archive',
}: ArchiveConfirmationModalProps) {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} className="md:w-[500px]">
      <Dialog.Header>
        <Dialog.Title />
      </Dialog.Header>
      <Dialog.Content>
        <P size="2xl" weight="medium">
          Are you sure you want to {action} this influencer?
        </P>
      </Dialog.Content>
      <Dialog.Footer>
        <div className="flex gap-2">
          <Button color="secondary" onClick={onClose}>
            No, Cancel
          </Button>
          <Button color="error" onClick={onConfirm}>
            Yes, {action.charAt(0).toUpperCase() + action.slice(1)}
          </Button>
        </div>
      </Dialog.Footer>
    </Dialog>
  );
}
